import React, { useState, useContext } from "react";
import { css } from "emotion";
import BillingTitle from "./BillingTitle";
import GenericButton from "../GenericButton";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import workspaces from "../../services/api/workspaces";

import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { GlobalContext } from "../../context/GlobalState";
import { BillingContext } from "../../context/BillingState";

const ELEMENT_OPTIONS = {
  classes: {
    base: "input-field",
  },
  style: {
    base: {
      fontSize: textSizes.intermediate,
      color: colors.inputTextColor,
      backgroundColor: colors.inputBackground,
    },
    empty: {
      "::placeholder": {
        color: colors.placeholderText,
      },
    },
    invalid: {
      color: "#9e2146",
    },
  },
};

const AddPaymentForm = () => {
  const { currentWorkspace } = useContext(GlobalContext);
  const { getCardsFlag, toggleGetCards } = useContext(BillingContext);
  const elements = useElements();
  const stripe = useStripe();
  const [cardRef, setCardRef] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }
    const card = elements.getElement(CardElement); // get the card element (all other details are implied)
    const result = await stripe.createToken(card); // create the token

    if (result.error) {
      // Inform the user if there was an error. ADDDDDDD HEEEEEEEEEEERRRRRRRRRREEEEEEEEEE
      console.log(result.error);
    } else {
      // Send the token and workspace ID to the server.
      const billingInfo = {
        workspace: currentWorkspace.id,
        stripeToken: result.token.id,
      };

      try {
        const addedCard = await workspaces.addPaymentMethod(billingInfo);
        // console.log(addedCard);
        toggleGetCards(!getCardsFlag);
        cardRef.clear();
      } catch (error) {
        console.log(error);
      }
    }
  };
  return (
    <div className={container}>
      <BillingTitle title="Add Payment Method" />
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <CardElement
            options={ELEMENT_OPTIONS}
            onReady={(e) => setCardRef(e)}
          />
        </div>
        <GenericButton style="form-button" text="Save Card" />
      </form>
    </div>
  );
};

export default AddPaymentForm;

const container = css`
  padding: ${boxStyles.desktopPadding} 0;
  form {
    .form-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: ${boxStyles.desktopPadding} 0;

      .input-field {
        border-radius: ${boxStyles.borderRadius};
        color: ${colors.placeholderText};
        background-color: ${colors.inputBackground};
        width: 100%;
        border: none;
        padding: ${boxStyles.standardPadding};
      }
    }
    .form-button {
      width: 180px;
      margin: auto;
    }
  }

  @media screen and (max-width: ${boxStyles.desktopBreak}) {
    padding: ${boxStyles.standardPadding};
  }
`;
